import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const CardElementWrapper = styled.div`
  width: 300px;
  height: 47px;
  margin-top: 5px;
  padding: 14px 20px 15px;
  border-radius: 2px;
  border: solid 1px ${themeGet('border.3', '#e6e6e6')};
  background-color: #ffffff;
  color: ${themeGet('text.3', '#8d8d8d')};

  @media only screen and (max-width: 1200px) {
    width: 100%;
  }

  @media only screen and (max-width: 991px) {
    margin-top: 0;
    margin-bottom: 5px;
  }

  @media only screen and (max-width: 767px) {
    margin-bottom: 10px;
  }

  &.card-error-styles {
    border: 1px solid red;
  }
`;

export const FormField = styled.div`
  display: flex;
  padding: 0 27px 73px;

  @media only screen and (max-width: 1200px) {
    width: 100%;
    justify-content: space-between;
  }

  @media only screen and (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 40px;
  }

  @media only screen and (max-width: 767px) {
    padding: 0;
  }
`;

export const CardInput = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 81px;
  justify-content: space-between;
  margin-right: 39px;

  @media only screen and (max-width: 1200px) {
    width: 48%;
    margin-right: 0;
  }

  @media only screen and (max-width: 991px) {
    min-height: 0;
    width: 100%;
  }

  @media only screen and (max-width: 767px) {
    .ant-checkbox + span {
      font-size: 15px;
      line-height: 24px;
      color: ${themeGet('text.0', '#2c2c2c')};
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e8eaec;
  width: 100%;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const FieldDescription = styled.div`
  display: flex;
  width: 294px;
  align-self: center;
  min-height: 63px;
  justify-content: space-between;

  @media only screen and (max-width: 1200px) {
    width: 48%;
  }

  @media only screen and (max-width: 991px) {
    height: auto;
    align-self: flex-start;
    margin-top: 25px;
    width: 100%;
    min-height: 0;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 28px;
  }

  img {
    width: 21px;
    height: 21px;
    object-fit: contain;
    margin-right: 10px;
    @media only screen and (max-width: 767px) {
      margin-top: 2px;
    }
  }
  p {
    font-size: 15px;
    line-height: 18px;
    color: black;

    @media only screen and (max-width: 991px) {
      width: 100%;
      margin-bottom: 0;
    }

    @media only screen and (max-width: 767px) {
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      color: ${themeGet('text.0', '#2C2C2C')};
    }
  }
`;

export const ActionsWrapper = styled.div`
  margin-bottom: 28px;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 0;
    position: fixed;
    bottom: 52px;
    left: 0;
    z-index: 1;
    background-color: ${themeGet('color.1', '#ffffff')};
    border-top: 1px solid ${themeGet('border.1', '#E8E8E8')};
    padding: 15px 20px;
  }
`;

export const SecurePaymentDescription = styled.div`
  display: flex;
  min-height: 20px;
  justify-content: center;
  margin-top: 12px;

  p {
    min-width: 165px;
    margin: 1px 0 1px 9px;
    font-size: 14px;
    line-height: 22px;
    color: ${themeGet('text.12', '#828282')};
  }
`;

export const TermsOfService = styled.div`
  min-height: 18px;
  margin-top: 16px;
  font-size: 15px;
  line-height: normal;
  text-align: center;
  p {
    color: ${themeGet('text.3', '#8d8d8d')};
    margin-bottom: 0;
    @media only screen and (max-width: 767px) {
      font-size: 16px;
    }
  }
  a {
    color: ${themeGet('primary.0', '#194AB9')};
  }
  @media only screen and (max-width: 767px) {
    align-self: flex-start;
    text-align: left;
  }
`;

export const PaidWrapper = styled.div`
  display: flex;
  min-height: 190px;
  flex-direction: column;
  justify-content: space-between;
`;

export const PaidTopSection = styled.div`
  min-height: 137px;
  padding-left: 28px;
  padding-right: 28px;
  padding-bottom: 36px;
  padding-top: 14px;
  border-radius: 4px;
  border: solid 1px #e8eaec;
  background-color: #fafafa;
`;

export const FieldTitle = styled.h4`
  min-height: 24px;
  margin-bottom: 0;
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: bold;
  color: #323232;
  line-height: 1.6;
`;

export const FieldContent = styled.div`
  box-sizing: border-box;
  height: 47px;
  border-radius: 2px;
  border: solid 1px #e8eaec;
  background-color: #ffffff;
  font-size: 15px;
  color: #cccccc;

  @media only screen and (max-width: 1200px) {
    width: 100%;
  }
  &.order-paid-at {
    padding-top: 14px;
    padding-left: 15px;
    padding-bottom: 11px;
  }
  &.card-details {
    padding-top: 11px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  margin-bottom: 24px;
`;

export const CardDetailsWrapper = styled.div`
  display: flex;
  width: 100px;
  justify-content: space-between;
`;

export const ErrorMessage = styled.div`
  color: red; ;
`;
